import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

const classes = {
    container: (primary, right) => classNames({
        'flex flex-col text-gray-700 h-full border-gray-200': true,
        'bg-indigo-700': primary,
        'bg-white': !primary,
        'border-l': right
    }),
    track: 'flex-grow overflow-auto',
    tray: 'p-4'
};

export default class Sidebar extends React.Component {
    static propTypes = {
        tray: PropTypes.instanceOf(Tray),
        header: PropTypes.instanceOf(Header),

        primary: PropTypes.bool,
        right: PropTypes.bool,
    };

    static defaultProps = {
        tray: null,
        header: null,
        primary: false,
        right: false,
    };

    render() {
        const {children, tray, header, primary, right} = this.props;

        return <div className={classes.container(primary, right)}>
            {header}
            <div className={classes.track}>
                {children}
            </div>
            {tray}
        </div>;
    }
}

export const Tray = ({children}) => <div className={classes.tray}>
    {children}
</div>;

export const Header = ({children}) => <div>
    {children}
</div>
